import { RESTRICTED_SYMBOLS, RESTRICTED_KEYWORDS } from '../../constants';
import { ReferenceMap } from '../../features/custom-worksheet-template/store/slice';
import { camelCase } from '../../utilities/formatting';

/**
 * With the provided name, generate a unique reference to ensure no duplicate
 *
 * @param name Property name
 * @param references List of existing references
 * @returns Unique property reference
 */
export function formatUniqueReference(name: string, references: ReferenceMap): string {
    let newFieldReference = camelCase(name);

    for (const char of RESTRICTED_SYMBOLS) {
        newFieldReference = newFieldReference.replaceAll(char, '');
    }

    // If new reference is an empty string after restricted symbols are removed, default it to 'field'
    if (newFieldReference.trim() === '') {
        newFieldReference = 'field';
    }

    const existingReferences = Object.keys(references).concat(RESTRICTED_KEYWORDS);

    let i = 0;
    while (existingReferences.find((r) => r === `${newFieldReference}${i > 0 ? `_${i}` : ''}`)) {
        i += 1;
    }
    newFieldReference = `${newFieldReference}${i > 0 ? `_${i}` : ''}`;

    return newFieldReference;
}

/**
 * Get property reference from the id
 *
 * @param id Property id
 * @returns Property reference
 */
export function getReference(id: string): string {
    return (id.split('.') || []).slice(-1)[0];
}

/**
 * Check if value is a keyword
 *
 * @param value
 * @returns True if it is a keyword otherwise false
 */
export function isKeyword(value: string): boolean {
    return RESTRICTED_KEYWORDS.find((keyword) => value.trim().toLowerCase() === keyword) !== undefined;
}

/**
 * Check if value has restricted symbols
 *
 * @param value
 * @returns Array of restricted symbols or undefined if none
 */
export function hasRestrictedSymbols(value: string): string[] | undefined {
    const restrictedSymbols = RESTRICTED_SYMBOLS.filter((symbol) => value.includes(symbol));
    return restrictedSymbols.length === 0 ? undefined : restrictedSymbols;
}
